import { render, staticRenderFns } from "./ModalApiError.vue?vue&type=template&id=38839e4f&scoped=true&"
import script from "./ModalApiError.vue?vue&type=script&lang=ts&"
export * from "./ModalApiError.vue?vue&type=script&lang=ts&"
import style0 from "./ModalApiError.vue?vue&type=style&index=0&id=38839e4f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38839e4f",
  null
  
)

export default component.exports